<div class="card-article my-3">
  <div class="card-article-picture">
    <img width="600" height="300" loading="lazy" [src]='article.image_path' alt="Actualités">
  </div>

  <div class="card-article-body text-start bg-white p-3 p-md-4">
    <div *ngIf="article.date" class="article-date mb-3 text-black-50">
      <i class="bi bi-calendar  me-2"></i>
      {{ article.date | dateFormatter }}
    </div>
    <div class="article-title bold-xl text-bleu-tdm my-2">
      {{ article.title }}
    </div>
    <div class="my-2">
      <span class="article-excerpt  text-gray">
        {{ article.resume }}
      </span>
    </div>
    <button type="button" (click)="goToDetailArticle()"
      class="btn text-black semibold-sm p-0 text-start border-0 bg-transparent">Lire la suite
      <i class="bi bi-arrow-right text-bleu-tdm mx-2"></i>
    </button>
  </div>
</div>
